<template>
    <div>
        <forms-grid :showBtns="showBtns"
                    :listAll="listAll"
                    :returnUrl="listAll ? '/forms/all' : ''">
        </forms-grid>
    </div>
</template>

<script>
    import FormsGrid from "@/components/forms/CompletedFormsGrid";

    export default {
        name: 'list-completed-forms-data',
        components: {
            FormsGrid
        },
        props: {
            showBtns: {
                default: true,
                type: Boolean
            },
            listAll: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                registerName: 'CompletedForms'
            };
        },
        methods: {

        },
        mounted: function () {

        },
        computed: {

        }
    }
</script>

<style scoped>
</style>
